export default class ServiceTypeRequestPtDetailEntity  {
    serviceTypeRequestPtDetailId: number;
    serviceTypeRequestPtId: number;
    specificBodyPartId: number;
    injuryTypeId: number;
    bodySideId: number;
    referralId: number;
}